import {defineStore} from 'pinia';
import {ModuleJusticeCase} from '../moduleConst';
import justiceCaseAPI from '@/apis/di/justiceCaseAPI';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore';
const justiceCaseStore = new BaseDictionaryStore(justiceCaseAPI);
export const useJusticeCaseStore = defineStore(ModuleJusticeCase, {
  state: () => ({
    ...justiceCaseStore.state,
    _config: {
      key: 'justice_case_id',
      code: 'justice_case_alias',
      name: 'justice_case_name',
      table: 'di_justice_case',
      quickFollow: 'active',
      moduleName: 'Bản án',
      defaultSort: 'justice_case_alias',
      columns: 'justice_case_id,justice_case_alias,justice_case_name,justice_case_date,description,active',
    },
    moduleName: 'diJusticeCase',
  }),
  actions: {...justiceCaseStore.action},
  getters: {
    ...justiceCaseStore.getters,
  },
});
